import Component from "./Component.js"

export default class ErrorMsg extends Component {

  static get contextTypes() {
    return super.contextTypes
  }
  
  onerror(event) {
    this.setState({error: this.l10n.MSG_ERROR_DEFAULT})
  }

  render() {
    return (
      <div className="amp-error-msg">
        <div dangerouslySetInnerHTML={{__html: this.state.error}} />
      </div>
    )
  }
}
